export default __webpack_public_path__ + "static/media/users-icon.4875a738.svg";